import styled from 'styled-components'

export const Form = styled.form`
	position: relative;
	width: 100%;
	margin: 0px auto;
	box-sizing: border-box;
`
